import { dndTypes } from '../constants';
import { DragSource } from 'react-dnd';
import FileItem from './FileItem'

const fileItemSource = {
  beginDrag(props) {
    return {
      label: props.label,
    };
  },
  endDrag(props, monitor) {
    if ( !monitor.didDrop() && props.unsetField) {
      props.unsetField();
    }
  },
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  }
}

export default DragSource(dndTypes.fileItem, fileItemSource, collect)(FileItem);
